import { createFileRoute, useParams } from '@tanstack/react-router';

import { PractitionerDetailScreen } from '@/features/practitioners/components/shared/PractitionerDetailScreen';

export const Route = createFileRoute('/_staff/admin/workspace/practitioners/$practitionerId/')({
  component: WorkspacePractitionerDetailRoute,
});

function WorkspacePractitionerDetailRoute() {
  const { practitionerId } = useParams({
    from: '/_staff/admin/workspace/practitioners/$practitionerId/',
  });
  return <PractitionerDetailScreen practitionerId={practitionerId} surface="workspace" />;
}
